import React from 'react';

class Select extends React.Component {
    render () {
        let children = this.props.children;

        if (this.props.rangeMin && this.props.rangeMax && this.props.rangeMin < this.props.rangeMax) {
            children = [];
            for (var i = this.props.rangeMin; i <= this.props.rangeMax; i++) {
                children.push((
                    <option key={i} value={i}>{i}</option>
                ));
            }
        }

        return (
            <select {...this.props} className={['component-select', this.props.className].join(' ')}>
                { children }
            </select>
        )
    }
}

export default Select;



// WEBPACK FOOTER //
// ./web-app/components/select.jsx